import { ROOF_MATERIAL } from '~/lib/graphql/types';
import type { QuestionItem } from '~/lib/store/types';

const questionsResidentialSg: QuestionItem[] = [
    {
        slug: 'roof-type',
        type: 'select',
        label: 'My rooftop type is...',
        input: 'roof',
        value: ROOF_MATERIAL.TILES_SIMPLE,
        validated: true,
        option: [
            {
                label: 'Simple tile roof',
                type: 'option',
                value: ROOF_MATERIAL.TILES_SIMPLE,
                asset: {
                    path: '/simple_tiled_roof.png',
                    width: 56,
                    height: 48
                },
                input: 'roof'
            },
            {
                label: 'Tile roof with dormer windows',
                type: 'option',
                value: ROOF_MATERIAL.TILES_COMPLEX,
                asset: {
                    path: '/tiled_roof_dormer_windows.png',
                    width: 56.15,
                    height: 48
                },
                input: 'roof'
            },
            {
                label: 'Metal roof',
                type: 'option',
                value: ROOF_MATERIAL.METAL,
                asset: { path: '/metal_roof.png', width: 56.15, height: 48 },
                input: 'roof'
            },
            {
                label: 'Concrete roof',
                type: 'option',
                value: ROOF_MATERIAL.CONCRETE,
                asset: { path: '/concrete_roof.png', width: 56.15, height: 48 },
                input: 'roof'
            },
            {
                label: 'Mixed roof',
                type: 'option',
                value: ROOF_MATERIAL.MIXED,
                asset: { path: '/mixed_roof.png', width: 56.15, height: 48 },
                input: 'roof'
            },
            {
                label: "I'm not sure / others",
                type: 'option',
                value: ROOF_MATERIAL.OTHER,
                asset: { path: '/unknown_roof.png', width: 56.15, height: 48 },
                input: 'roof'
            }
        ]
    },
    {
        slug: 'storeys',
        label: 'My house is...',
        type: 'select',
        input: 'storeys',
        value: '1',
        validated: true,
        option: [
            {
                label: 'Single storey',
                type: 'option',
                value: '1',
                input: 'storeys'
            },
            {
                label: '2 storeys',
                type: 'option',
                value: '2',
                input: 'storeys'
            },
            {
                label: '3 storeys',
                type: 'option',
                value: '3',
                input: 'storeys'
            },
            { label: '4 storeys', type: 'option', value: '4', input: 'storeys' }
        ]
    },
    {
        slug: 'meter-box',
        label: 'My meter box is...',
        type: 'select',
        input: 'meter_box',
        value: 'SINGLE_PHASE',
        validated: true,
        option: [
            {
                label: 'Single phase',
                type: 'option',
                value: 'SINGLE_PHASE',
                input: 'meter_box'
            },
            {
                label: '3 phase',
                type: 'option',
                value: 'THREE_PHASE',
                input: 'meter_box'
            },
            {
                label: "I don't know",
                type: 'option',
                value: 'USER_UNSURE',
                input: 'meter_box'
            }
        ]
    },
    {
        slug: 'electricity',
        type: 'grouped',
        groupedQuestions: [
            {
                label: 'My monthly electricity bill is...',
                type: 'currency',
                validated: true,
                value: '250',
                input: 'utilities',
                billHintValues: [200, 300, 400, 500]
            },
            {
                label: 'My electricity retailer is...',
                type: 'dropdown',
                input: 'retailer',
                value: 'SPGROUP',
                validated: true
            },
            {
                label: 'I use my electricity...',
                type: 'select',
                input: 'dayTimeConsumption',
                value: 'MORNING_AND_NIGHT',
                validated: true,
                option: [
                    {
                        label: 'Mostly during the mornings and evenings',
                        type: 'option',
                        value: 'MORNING_AND_NIGHT',
                        input: 'dayTimeConsumption'
                    },
                    {
                        label: 'Equally throughout the day',
                        type: 'option',
                        value: 'EQUALLY_THROUGHOUT_DAY',
                        input: 'dayTimeConsumption'
                    }
                ]
            }
        ]
    }
];

export default questionsResidentialSg;
